import { render, staticRenderFns } from "./aiot.vue?vue&type=template&id=737d38b9&scoped=true&"
import script from "./aiot.vue?vue&type=script&lang=js&"
export * from "./aiot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d38b9",
  null
  
)

export default component.exports